import {WatchQueryFetchPolicy, gql} from '@apollo/client';

import {QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {RequestTaskSchemaGraphQL} from '../../../graphql-fragments/requests/schemas/__generated/RequestTaskSchemaGraphQL';
import {AllRequestTaskSchemasQuery} from './__generated/AllRequestTaskSchemasQuery';

export const ALL_REQUEST_TASK_SCHEMAS_QUERY = gql`
  query AllRequestTaskSchemasQuery @skipAudit @engComponent(name: REQUESTS) {
    ...AllRequestTaskSchemasGraphQL
  }
  ${getFragmentWrapper('AllRequestTaskSchemas').fragment}
`;

export default function useAllRequestTaskSchemasQuery(
  fetchPolicy?: WatchQueryFetchPolicy
): Array<RequestTaskSchemaGraphQL> | null {
  const result = useBenchlingQuery<AllRequestTaskSchemasQuery>(ALL_REQUEST_TASK_SCHEMAS_QUERY, {fetchPolicy});
  return result.type === QueryResultType.SUCCESS ? result.data.requestTaskSchemas : null;
}
